
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/side-effects",
      function () {
        return require("private-next-pages/side-effects.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/side-effects"])
      });
    }
  